import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import {
  catchError,
  filter,
  map,
  switchMap,
  takeUntil,
  tap
} from 'rxjs/operators';
import { InsuranceService } from '../../../services/insurance.service';
import { PVIPlanDetail } from '@gtd/api-services/service-inventory';
import { UnsubscribeService } from '@gtd/hotels/data-access/services';

@Component({
  selector: 'gtd-pvi-plans',
  templateUrl: './pvi-plans.component.html',
  styleUrls: ['./pvi-plans.component.scss'],
  providers: [UnsubscribeService]
})
export class PviPlansComponent implements OnInit, OnChanges, OnDestroy {
  @Input() bookingNumber: string;
  @Input() type: 'DOME' | 'INTE';
  @Input() availablePlans: { label: string; value: string }[];
  @Input() ageCalculateDate: string | Date;

  planControl = new FormControl(null);
  planDetails$: Observable<PVIPlanDetail[]>;
  insurers$ = this.insuranceService.insurers$;
  price: number;

  constructor(
    private insuranceService: InsuranceService,
    private unsubscribeService: UnsubscribeService
  ) {}

  ngOnInit() {
    this.planDetails$ = this.planControl.valueChanges.pipe(
      switchMap(planType =>
        this.insurers$.pipe(
          filter(insurers => insurers && insurers.length > 0),
          takeUntil(this.unsubscribeService.unsubscribe$),
          switchMap(insurers =>
            this.insuranceService
              .getPlans({
                bookingNumber: this.bookingNumber,
                planType: planType,
                personalInfo: this.insuranceService.mapToPersonalInfo(
                  insurers,
                  this.ageCalculateDate
                )
              })
              .pipe(
                filter(response => response.success),
                map(response => response.result),
                tap(availablePlan =>
                  this.insuranceService.setPlanSelected(planType, availablePlan)
                ),
                map(result => result.detail),
                catchError(error => {
                  console.error(error);
                  return of(null);
                })
              )
          )
        )
      )
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { availablePlans } = changes;
    if (!availablePlans) {
      return;
    }

    this.planControl.setValue(availablePlans.currentValue[0].value);
  }

  ngOnDestroy() {
    this.unsubscribeService.destroy();
  }
}
